<template>
	<div>
		<div>
			<div class="flex xs-12 xs-between mt6">
				<div class="fs4 lh125 fw7 c1 mb2">{{ $t("plan") }}</div>
				<j-button
					v-can:or="['writePlans']"
					type="tertiary"
					@click="$modal.show('updatePlan')"
				>
					<crm-icon name="edit" color="c2" size="small" />
					{{ $t("update") }}
				</j-button>
			</div>
			<j-card class="bg5">
				<j-list :list="computedPlan">
					<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
						<div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">
							{{ item.label }}
						</div>
						<div class="flex xs-6 xs-left xs-middle lh125">
							{{ item.value || "---" }}
						</div>
					</div>
				</j-list>
				<div class="bg5 ta2 fs3 p2" v-if="!computedPlan">
					{{ $t("errors.no_data") }}
				</div>
			</j-card>
		</div>

		<!-- Update Plan Modal -->
		<core-modal name="updatePlan" :headline="$t('update_plan')">
			<div class="p4">
				<core-form-input
					name="name"
					componentName="j-base-input-text"
					:label="$t('name')"
					v-validate="{ required: true }"
					:validationErrors="errors"
					v-model="form.name"
				/>
				<core-form-input
					class="mt6"
					name="description"
					componentName="j-base-input-long-text"
					:label="$t('description')"
					v-validate="{ required: true }"
					:validationErrors="errors"
					v-model="form.description"
				/>
				<j-button class="mt6" :isLoading="isLoading" @click="updatePlan">{{
					$t("update")
				}}</j-button>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JCard from "@/components/JCard/"
import JList from "@/components/JList/"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import CoreModal from "@/modules/core/components/CoreModal"
import CoreFormInput from "@/modules/core/components/CoreFormInput"

import api from "../api"

export default {
	props: {
		data: {
			type: Object,
			required: true
		},

		selectedLocale: String
	},

	components: {
		JCard,
		JList,
		JButton,
		CrmIcon,
		CoreModal,
		CoreFormInput
	},

	data() {
		return {
			transactionToUpdateId: null,
			transactionToUpdatePayload: null,
			isLoading: false,
			form: {
				name: null,
				description: null
			}
		}
	},

	methods: {
		async updatePlan() {
			const { plan, type, version } = this.data.id

			this.isLoading = true

			// localize plan by upserting name and description
			if (this.form.name) {
				const res = await api.localizePlan({
					l10n: {
						key: `products-${plan}|${version || ""}|${type}-name`,
						locale: this.selectedLocale,
						value: this.form.name
					}
				})

				if (res?.data?.upsertL10n?.status !== "success") {
					this.$store.dispatch("addMessage", {
						message: {
							type: "error",
							text:
								res?.errors ||
								res?.data?.createPlan?.errors ||
								res?.data?.createPlan?.errors_2?.message ||
								"Oops ! An error occured."
						}
					})
					return
				}
			}

			if (this.form.description) {
				const res2 = await api.localizePlan({
					l10n: {
						key: `products-${plan}|${version || ""}|${type}-description`,
						locale: this.selectedLocale,
						value: this.form.description
					}
				})

				if (res2?.data?.upsertL10n?.status !== "success") {
					this.$store.dispatch("addMessage", {
						message: {
							type: "error",
							text:
								res2?.errors ||
								res2?.data?.createPlan?.errors ||
								res2?.data?.createPlan?.errors_2?.message ||
								"Oops ! An error occured."
						}
					})
					return
				}
			}

			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("plan_updated")
				}
			})

			this.isLoading = false

			this.$modal.hide("updatePlan")

			this.$emit("plan:updated")
		}
	},

	computed: {
		computedPlan() {
			if (!this.data) return []
			const data = [
				{ label: this.$t("name"), value: this.data.name },
				{ label: this.$t("plan"), value: this.data.id.plan },
				{ label: this.$t("type"), value: this.data.id.type },
				{ label: this.$t("version"), value: this.data.id.version },
				{ label: this.$t("description"), value: this.data.description }
			]
			return data
		}
	},

	watch: {
		data: {
			handler() {
				this.form.name = this.data?.name
				this.form.description = this.data?.description
			},
			deep: true,
			immediate: true
		}
	}
}
</script>
